import { listItemMsg } from '@/shared/components/FormattedListValue';

const RenderProperty = props => {
  const { log, intl } = props;

  return log.fieldId !== null
    ? intl.formatMessage(listItemMsg('field', log.fieldId))
    : log.label
    ? intl.formatMessage({ id: log.label, defaultMessage: log.label })
    : log.property;
};

export default RenderProperty;
